// extracted by css-extract-rspack-plugin
export default {"skeletonAdviceCardContent":"skeleton-advice-card-content--CgXcIzqxoBYOOOqF"};